var _style, _rect, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootballCourt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 180",
    style: {
      enableBackground: "new 0 0 400 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.11;fill:#004202;enable-background:new    ;}\n\t.st2{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 197.5443,
    cy: -25.8,
    r: 350.63,
    gradientTransform: "matrix(1.05 0 0 -0.71 -8.45 71.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82D748"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#519D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#195A0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#034002"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 400,
    height: 180
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.7,180H36.4V0h36.4V180z M145.4,0h-36.4v180h36.4V0z M218.2,0h-36.4v180h36.4V0z M290.9,0h-36.4v180h36.4V0z  M363.6,0h-36.4v180h36.4V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M391.1,176.7H8.9V3.3h382.3L391.1,176.7L391.1,176.7z M10.7,175.3h378.6V4.7H10.7V175.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M391.1,131.8h-47.3V48.2h47.3V131.8L391.1,131.8z M345.6,130.5h43.6v-81h-43.6V130.5L345.6,130.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M391.1,111.9h-16.6V68.1h16.6V111.9z M376.4,110.6h12.9V69.4h-12.9V110.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M396.8,101.7h-7.5V78.4h7.5C396.8,78.4,396.8,101.7,396.8,101.7z M391.1,100.3h3.8V79.7h-3.8V100.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200,118.9c-22.3,0-40.4-13-40.4-28.9s18.1-28.9,40.4-28.9s40.4,13,40.4,28.9S222.3,118.9,200,118.9z  M200,62.4c-21.2,0-38.5,12.4-38.5,27.6s17.3,27.6,38.5,27.6s38.6-12.4,38.6-27.6S221.3,62.4,200,62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200,92.4c-1.9,0-3.4-1.1-3.4-2.4s1.5-2.4,3.4-2.4s3.4,1.1,3.4,2.4S201.9,92.4,200,92.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.1,
    y: 3.9,
    className: "st2",
    width: 1.8,
    height: 172.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.2,131.8H8.9V48.2h47.3L56.2,131.8L56.2,131.8z M10.7,130.5h43.7v-81H10.7V130.5L10.7,130.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.5,111.9H8.9V68.1h16.6V111.9z M10.7,110.6h12.9V69.4H10.7C10.7,69.4,10.7,110.6,10.7,110.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.7,101.7H3.2V78.4h7.5C10.7,78.4,10.7,101.7,10.7,101.7z M5,100.3h3.8V79.7H5C5,79.7,5,100.3,5,100.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootballCourt);
export default __webpack_public_path__ + "static/media/football-court.b47b4451efa8118da5d21626ab6ad646.svg";
export { ForwardRef as ReactComponent };